import React from 'react'
import { type ClassValue } from 'clsx'
import { cn } from '@/lib/utils'

const CustomCard: React.FC<
  React.PropsWithChildren<
    {
      className?: ClassValue
    } & React.HTMLAttributes<HTMLDivElement>
  >
> = ({ children, className, ...props }) => {
  return (
    <div
      className={cn('tw-border tw-rounded-2xl tw-shadow-md', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export default CustomCard
